import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const categories = async (data: { pageParam?: number }) =>
  axios.get(Routes.CATEGORIES + `?page=${data?.pageParam ?? 1}`);

export const useCategories = () => {
  return useInfiniteQuery({
    queryKey: [Keys.CATEGORIES_QRY],
    queryFn: categories,
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
